import React from 'react';
import { useRouter } from 'next/router';
import { List, ListItem, Typography } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import { initFalse } from '../../utils/constants';
import { Dialog, DialogContent, DialogHeader } from '../dialog';
import { Button, ButtonProps } from '../formikFormInputs';

const RegistrationConfirmation = () => {
  const router = useRouter();
  const [open, setOpen] = React.useState(!initFalse);
  const termsToAgreeBeforeRegister = [
    // 'Agents must be affiliated with an approved IMO.',
    'Agents must have a non-resident Life Insurance License in Nevada.'
  ];
  const agreeButtonProps: ButtonProps = {
    className: 'floatRight mt20',
    color: 'primary',
    label: 'Agree',
    onClick: () => setOpen(initFalse),
    size: 'small',
    type: 'button',
    variant: 'contained',
  };
  const disAgreeButtonProps: ButtonProps = {
    className: 'bgRed floatLeft mt20',
    label: 'Disagree',
    onClick: () => router.back(),
    size: 'small',
    type: 'button',
    variant: 'contained',
  };
  const buttonProps: ButtonProps[] = [disAgreeButtonProps, agreeButtonProps];

  return (
    <Dialog open={open}>
      <DialogHeader>
        Before You Register
      </DialogHeader>
      <DialogContent dividers>
        <Typography>
          You must agree to the following terms to become an approved agent.
        </Typography>

        <List>
          {
            termsToAgreeBeforeRegister.map((lItem, lIdx) => (
              <ListItem key={lIdx} className="pl0">
                <DoneIcon className="colorGreen"/>
                <Typography className="ml10" color="primary" component="strong">
                  {lItem}
                </Typography>
              </ListItem>
            ))
          }
        </List>

        {
          buttonProps.map((bp, idx) => (<Button key={idx} {...bp} />))
        }
      </DialogContent>
    </Dialog>
  );
};

export default RegistrationConfirmation;
